import { createBrowserRouter } from 'react-router';

import { routes } from '@@router/routes';
import { useSettingsStore } from '@@scripts/store/settings/useSettingsStore';

export const router = createBrowserRouter(routes);

// Mirror the pathname for code outside React, such as the Content-Language header in `api/headers.ts`
router.subscribe((state) => {
    useSettingsStore.getState().setPathname(state.location.pathname);
});

// A route config update creates a new router, so the old one must stop listening to history
import.meta.hot?.dispose(() => {
    router.dispose();
});
